import { render, staticRenderFns } from "./WordLoadMobile.vue?vue&type=template&id=375fe5c4&scoped=true&"
import script from "./WordLoadMobile.vue?vue&type=script&lang=js&"
export * from "./WordLoadMobile.vue?vue&type=script&lang=js&"
import style0 from "./WordLoadMobile.vue?vue&type=style&index=0&id=375fe5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375fe5c4",
  null
  
)

export default component.exports